import React from 'react';
import ReactDOM from 'react-dom';
import './static/css/index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { paths, main, menuItems } from './Constants';
import CustomNavBar from './components/navbar/navbar';


const domElement = document.getElementById('chatbot-avanti');
console.log('domElement', domElement);
ReactDOM.render(
  <React.StrictMode>
      <CustomNavBar items={paths} main={main} menuItems={menuItems} containerData={domElement.dataset} />
  </React.StrictMode>,
  document.getElementById('chatbot-avanti')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
